define([
	"dojo/_base/declare",
	"csi/action/FreezeController"
], function(declare,FreezeController) {

	return declare(FreezeController, {
		_toCallWriter: function() {
			this.m_writer.freezeNode(this.m_urlNode, false);
		}
	});
});